module.exports = __webpack_public_path__ + "img/gry_3.272f1e26.png";